import { AppBar, Toolbar, Box, IconButton } from '@mui/material';
import React, { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useNavigate } from 'react-router-dom';
import HiddenNavbar from './HiddenNavbar.jsx';
import SubMenu from './SubMenu.jsx';
import { collapsedListItems, hiddenNavbarItems, pagesInfo, submenuItems } from './navbarData.js';

const Navbar = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isCollapsedListOpen, setIsCollapsedListOpen] = useState(false);

    const navigate = useNavigate();
    const { userRole } = localStorage.getItem("cncToken") ? JSON.parse(localStorage.getItem("cncToken")) : navigate("/auth/login");

    const handleSetIsMenuOpen = () => {
        setIsMenuOpen(prevState => !prevState);
    }

    const handleSetIsCollapsedListOpen = () => {
        setIsCollapsedListOpen(prevState => !prevState);
    }

    return (
        <Box>
            <AppBar position="fixed"
                sx={{
                    height: "4rem",
                    zIndex: 1998
                }}
            >
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "100%" }}>
                    <Box>
                        <Box sx={{
                            display: {
                                xs: "none",
                                md: "flex"
                            },
                            alignItems: "center"
                        }}>
                            {pagesInfo.map((page, index) => {
                                return page.roles.includes(userRole.id) ? (
                                    <Link key={`${Math.random()}_${index}`}
                                        to={page.to} className="mx-3 nav-item">
                                        {page.text}
                                    </Link>
                                ) : null
                            })}
                            <Box className="mx-3">
                                <span className="nav-item cursor-pointer"
                                    onClick={(ev) => setAnchorEl(ev.target)}>
                                    حساب
                                </span>
                                {/* Start sub menu */}
                                <SubMenu
                                    anchorEl={anchorEl}
                                    setAnchorEl={setAnchorEl}
                                    submenuItems={submenuItems}
                                />
                                {/* End sub menu */}
                            </Box>
                        </Box>
                        <IconButton
                            size="large"
                            edge="end"
                            color="inherit"
                            sx={{
                                display: {
                                    xs: "flex",
                                    md: "none"
                                },
                                width: 50,
                                height: 50,
                                justifyContent: "center",
                                alignItems: "center"

                            }}
                            onClick={handleSetIsMenuOpen}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                    <Link to="/" className="text-2xl">
                        cnc
                    </Link>
                </Toolbar>
            </AppBar>
            {/* Start hidden navbar */}
            <HiddenNavbar
                isMenuOpen={isMenuOpen}
                handleSetIsMenuOpen={handleSetIsMenuOpen}
                hiddenNavbarItems={hiddenNavbarItems}
                isCollapsedListOpen={isCollapsedListOpen}
                handleSetIsCollapsedListOpen={handleSetIsCollapsedListOpen}
                collapsedListItems={collapsedListItems}
                userRole={userRole}
                anchor="right"
            />
            {/* End hidden navbar */}
        </Box>
    );
}

export default Navbar;
